"use client";

import { c as _c } from "react/compiler-runtime";
import { FilterValue, Region } from '@/shared/types/type/search';
import { Filter } from "@/widgets/search/ui/molecules";
import { TreatmentSearch } from "@/widgets/search/ui/organisms";
import { AutoComplete, RecentSearchKeyword, SearchBar } from "@/features/search/ui";
import { Spacer, Typography } from '@/shared/ui/atoms';
import { useSearchUiStore } from "@/features/search/model/ui/store";
import { useEffect } from 'react';
import { useSearchUiPersistStore } from '@/features/search/model/ui/store';
import { useTranslations } from 'next-intl';
interface SearchTemplateProps {
  regionList: Region[];
  treatmentList: FilterValue[];
}
const SearchTemplate = t0 => {
  const $ = _c(25);
  const {
    regionList,
    treatmentList
  } = t0;
  const t = useTranslations();
  const {
    keyword,
    resetSearchAll,
    isSearchBarFocused,
    setIsSearchBarFocused
  } = useSearchUiStore();
  let t1;
  let t2;
  if ($[0] !== setIsSearchBarFocused) {
    t1 = () => {
      useSearchUiPersistStore.persist.rehydrate();
      return () => {
        setIsSearchBarFocused(false);
      };
    };
    t2 = [setIsSearchBarFocused];
    $[0] = setIsSearchBarFocused;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  let t4;
  if ($[3] !== resetSearchAll) {
    t3 = () => {
      resetSearchAll();
    };
    t4 = [resetSearchAll];
    $[3] = resetSearchAll;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  const t5 = `bg-white flex-1 flex flex-col min-h-screen ${isSearchBarFocused ? "h-screen" : ""}`;
  let t6;
  if ($[6] !== t) {
    t6 = t("title");
    $[6] = t;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <Typography size={20} lineHeight={28} className="py-[13px] pl-4 text-gray-900 font-bold">{t6}</Typography>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <SearchBar />;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== regionList) {
    t9 = <div className="sticky top-0 z-[100] bg-white">{t8}<Filter regionList={regionList} /></div>;
    $[11] = regionList;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== isSearchBarFocused || $[14] !== keyword.length || $[15] !== treatmentList) {
    t10 = !isSearchBarFocused && keyword.length < 2 && <><TreatmentSearch treatmentList={treatmentList} /><Spacer size={8} /></>;
    $[13] = isSearchBarFocused;
    $[14] = keyword.length;
    $[15] = treatmentList;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== keyword.length) {
    t11 = keyword.length < 2 ? <RecentSearchKeyword /> : <AutoComplete />;
    $[17] = keyword.length;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== t10 || $[20] !== t11 || $[21] !== t5 || $[22] !== t7 || $[23] !== t9) {
    t12 = <section className={t5}>{t7}{t9}{t10}{t11}</section>;
    $[19] = t10;
    $[20] = t11;
    $[21] = t5;
    $[22] = t7;
    $[23] = t9;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  return t12;
};
export default SearchTemplate;